import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/EmailVerification.css'
import { SendVerificationEmailService} from "../../Services/DjangoServices"

export default class EmailVerification extends Component {
        constructor(props) {
                super(props);
                this.state = {
                        email: props.email,
                        first_name: props.first_name,
                        image_src: "/images/Dashboard/businessman_waving.png",
                        initial: true,
                        sending_email: false,
                        email_sent: false,
                }
        }

        send_email = () => {
                console.log("i called")
                this.setState({
                        image_src: "/images/Dashboard/businessman_phone.png",
                        initial: false,
                        sending_email: true, 
                })
                SendVerificationEmailService().then((result) => {
                        result.json().then((data) => {
                                console.log(data)
                                if ("already_email_sent" in data){
                                        this.setState({
                                                image_src: "/images/Dashboard/businessman_thumbup.png",
                                                sending_email: false,
                                                email_already_sent: true,
                                                sent_time: data["sent_datetime"],
                                        })
                                }
                                if ("email_sent" in data)
                                {
                                        this.setState({
                                                image_src: "/images/Dashboard/businessman_thumbup.png",
                                                sending_email: false,
                                                email_sent: true,
                                                sent_time: data["sent_datetime"]
                                        })
                                }
                        });
                });
        }

        render() {
                return (
                        <div id="main-email-varification">
                                <div className="container" align="center" style={{ zIndex: 100 }}>
                                        <img src={this.state.image_src} id="businessman-image" alt="businessman"></img>
                                        <h1 className="mt-3">Hello {this.state.first_name}</h1>
                                        {
                                                this.state.initial ?
                                                        <div>
                                                                {console.log("initial")}
                                                                <p className="info-text">Your email address <span className="font-weight-bold" >{this.state.email}</span> is not verified yet!</p>
                                                                <p className="info-text">Please click on the button below if you didn't receive any account activation email.</p>
                                                                <button className="btn btn-primary" onClick={() => { this.send_email() }} >SEND EMAIL</button>
                                                        </div>
                                                        :
                                                        null
                                        }
                                        {
                                                this.state.sending_email ?
                                                        <div>
                                                                <p className="info-text">We are sending an email to your email address <span className="font-weight-bold" >{this.state.email}</span></p>
                                                                <p className="info-text">Please open your email and click the activate account button and activate your account.</p>
                                                        </div>
                                                        :
                                                        null
                                        }
                                        {
                                                this.state.email_sent ?
                                                        <div>
                                                                <p className="info-text">We have sent an account activation mail to <span className="font-weight-bold" >{this.state.email}</span></p>
                                                                <p className="info-text">Date Time: <span className="font-weight-bold" >{this.state.sent_time}</span></p>
                                                                <p className="info-text">Please open your email and click the activate account button and activate your account.</p>
                                                                <p className="info-text">In case you didn't receive the email click the button below</p>
                                                                <button className="btn btn-primary" onClick={() => { this.send_email() }} >SEND EMAIL AGAIN</button>
                                                        </div>
                                                        :
                                                        null
                                        }
                                        {
                                                this.state.email_already_sent ?
                                                        <div>
                                                                <p className="info-text">We have already sent an account activation mail to <span className="font-weight-bold" >{this.state.email}</span></p>
                                                                <p className="info-text">Date Time: <span className="font-weight-bold" >{this.state.sent_time}</span></p>
                                                                <p className="info-text">Please open your email and click the activate account button and activate your account.</p>
                                                                <p className="info-text">We can't send a new email to you right now, It will be sent after 24 hours from the datetime mentioned above</p>
                                                        </div>
                                                        :
                                                        null
                                        }
                                </div>
                        </div>
                )
        }
}
